import { Button, FloatingPosition, Group, ThemeIcon } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import { useSignOut } from "../../utils/useSignOut";
import { ProjectSwitcher } from "./ProjectSwitcher";

export function SessionActions({
  menuPosition,
}: {
  menuPosition?: FloatingPosition;
}) {
  const { signOut } = useSignOut();

  return (
    <Group gap="xs">
      <ProjectSwitcher
        menuPosition={menuPosition}
        disableCreateProject
        hideIfNoOtherProjects
        switcherTarget={
          <Button size="xs" variant="transparent" c="dimmed">
            Switch project
          </Button>
        }
      />
      <Button
        size="xs"
        variant="transparent"
        c="red"
        rightSection={
          <ThemeIcon variant="transparent" size="xs" c="red">
            <IconLogout />
          </ThemeIcon>
        }
        onClick={signOut}
      >
        Sign out
      </Button>
    </Group>
  );
}
